import { FaPaperPlane } from "react-icons/fa";
import SocialMedia from "../SocialMedia";

export default function Footer() {
  return (
    <div className="bg-darkblue/90 text-white md:px-[15%] px-4 pt-14 pb-5">
      <ContactForm />
      <MediaCard cName="md:hidden block mt-8" />
      <div className="text-center mt-10">
        Thank you for visiting my portfolio website. Looking forward to
        connecting with you!
        <address className="mt-4">
          &copy; copy right reserved for {new Date().getFullYear()}
        </address>
      </div>
    </div>
  );
}

function ContactForm() {
  return (
    <div className="md:flex md:bg-white">
      <div className="flex-1 md:bg-darkorange text-white p-8">
        <h3 className="text-xl">Let's get in touch</h3>
        <p className="mb-5">
          If you have a project in mind or would like to discuss how I can help
          you, feel free to reach out via the contact form or email me directly
          at
          <a href="mailto:konakech3@gmail.com"> konakech3@gmail.com</a> Let's
          create something amazing together!
        </p>
        <MediaCard />
      </div>
      <div className="bg-white text-black md:p-8 p-5 flex-1 md:rounded-none rounded-md">
        <h3 className="text-2xl text-darkorange mb-5">How Can I help?</h3>
        <form>
          <div className="mb-5">
            <input
              className="h-[3rem] w-full bg-gray-100 border border-darkorange focus:border-none focus:outline-none rounded-md px-4"
              type="text"
              placeholder="Your name"
            />
          </div>
          <div className="mb-5">
            <input
              className="h-[3rem] w-full bg-gray-100 border border-darkorange focus:border-none focus:outline-none rounded-md px-4"
              type="text"
              placeholder="E-mail address"
            />
          </div>
          <div className="mb-5">
            <textarea
              className="md:h-[7rem] h-[10rem] w-full bg-gray-100 border border-darkorange focus:border-none focus:outline-none rounded-md px-4 py-3 resize-none"
              placeholder="How Can I help you...?"
            ></textarea>
          </div>
          <button className="w-full bg-darkorange py-2 rounded-md flex items-center justify-center">
            <FaPaperPlane className="mr-2" />
            Send
          </button>
        </form>
      </div>
    </div>
  );
}

function MediaCard({ cName = "md:block hidden" }) {
  return (
    <div className={cName}>
      <h3 className="text-xl mb-6 md:text-left text-center">Follow me on</h3>
      <SocialMedia
        upperCname="md:justify-start justify-evenly"
        cName="rounded md:text-2xl text-2xl text-white bg-darkorange md:bg-darkblue md:p-3 p-2 rounded-full md:mr-5"
      />
    </div>
  );
}

// function ContactInfo() {
//   return (
//     <div className="md:bg-white md:text-inherit text-white md:w-[40%] md:p-8 p-4 md:mt-0 mt-5">
//       <h3 className="md:text-2xl mb-4">Address & contacts</h3>
//       <ul>
//         <li className="flex  items-center mb-5">
//           <span className="text-xl mr-2 border border-darkorange text-darkorange p-2 rounded-full">
//             <FaMapMarkerAlt />
//           </span>
//           Juba, South Sudan
//         </li>
//         <li className="flex  items-center mb-5">
//           <span className="text-xl mr-2 border border-darkorange text-darkorange p-2 rounded-full">
//             <FaPhoneAlt />
//           </span>
//           +211920079070
//         </li>
//         <li className="flex  items-center mb-5">
//           <span className="text-xl mr-2 border border-darkorange text-darkorange p-2 rounded-full">
//             <FaWhatsapp />
//           </span>
//           +211920079070
//         </li>
//         <li className="flex  items-center mb-5">
//           <span className="text-xl mr-2 border border-darkorange text-darkorange p-2 rounded-full">
//             <FiMail />
//           </span>
//           konakech3@gmail.com
//         </li>
//       </ul>
//       <div className="md:mt-16 mt-8">
//         <h2 className="md:text-xl text-center md:mb-4 mb-4">
//           FOLLOW <span className="text-darkorange">ME</span> ON
//         </h2>
//         <SocialMedia cName="rounded md:text-2xl text-2xl text-darkorange md:border hover:border-darkorange p-2 rounded-full md:ml-4" />
//       </div>
//     </div>
//   );
// }

// function ContactForm() {
//   return (
//     <div className="bg-darkorange text-white flex-1 md:p-8 p-5">
//       <h3 className="text-xl mb-2">Let's Get In Touch</h3>
//       <p className="mb-5">
//         If you have a project in mind or would like to discuss how I can help
//         you, feel free to reach out via the contact form or email me directly at
//         <a href="mailto:konakech3@gmail.com"> konakech3@gmail.com</a> Let's
//         create something amazing together!
//       </p>
//       <form>
//         <div className="mb-5">
//           <input
//             className="h-[3rem] w-full bg-white border-none focus:border-none focus:outline-none rounded-md px-4"
//             type="text"
//             placeholder="Your name"
//           />
//         </div>
//         <div className="mb-5">
//           <input
//             className="h-[3rem] w-full bg-white border-none focus:border-none focus:outline-none rounded-md px-4"
//             type="text"
//             placeholder="E-mail address"
//           />
//         </div>
//         <div className="mb-5">
//           <textarea
//             className="h-[7rem] w-full bg-white border-none focus:border-none focus:outline-none rounded-md px-4 py-3"
//             placeholder="How Can I help you...?"
//           ></textarea>
//         </div>
//         <button className="w-full bg-darkblue py-2 rounded-md flex items-center justify-center">
//           <FaPaperPlane className="mr-2" />
//           Send
//         </button>
//       </form>
//     </div>
//   );
// }
